import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb as AntBreadcrumb } from 'antd';

class Breadcrumb extends Component {
  isLink = (item) => item.length > 1;

  render() {
    const { items } = this.props;
    return (
      <AntBreadcrumb>
        {/* eslint-disable-next-line react/prop-types */}
        {items.map((item) => (
          <AntBreadcrumb.Item key={item[0]}>
            {this.isLink(item) ? (
              <Link to={item[1]}>{item[0]}</Link>
            ) : (
              item[0]
            )}
          </AntBreadcrumb.Item>
        ))}
      </AntBreadcrumb>
    );
  }
}

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};

export default Breadcrumb;
